"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _immutable = require("immutable");
/* loading Slice of State
 *
 * This is a special reducer which checks every dispatched Action.
 * If the Action has `key` and `promise` attributes in its payload then
 * the Promise is stored in this Slice of State (SoS) using `key`.
 * The key is unset in this Slice of State when it is found in another
 * payload without a `promise` attribute.
 */

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (Object.prototype.hasOwnProperty.call(action, 'payload') && _typeof(action.payload) === 'object' && Object.prototype.hasOwnProperty.call(action.payload, 'key')) {
    // Actions that set loading should have a promise in the payload
    if (Object.prototype.hasOwnProperty.call(action.payload, 'promise')) {
      return state.set(action.payload.key, action.payload.promise);
    }
    // Actions that unset loading have the same key but no promise in the payload
    if (state.has(action.payload.key)) {
      return state.delete(action.payload.key);
    }
  }
  return state;
}